import {
  Label
} from "./chunk-EGHU7XEZ.mjs";
import {
  init_utils
} from "./chunk-SBNKSDBP.mjs";
import {
  cn
} from "./chunk-CVRFJC2Q.mjs";

// src/components/form-control/form-control.tsx
import React from "react";
init_utils();
var formControlClassNames = {
  label: "mx-0 p-0",
  root: "mb-4 w-full space-y-2",
  caption: "mx-0 p-0 my-body-xs text-foreground",
  error: "text-semantic-critical-foreground-bold mx-0 p-0 my-body-xs",
  feedback: "mx-0 p-0"
};
var FormControl = ({
  label,
  caption,
  className,
  error,
  children,
  htmlFor,
  feedback,
  tooltip,
  optional
}) => {
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "mb-1 flex items-center justify-between" }, /* @__PURE__ */ React.createElement("div", { className: "flex items-center space-x-2" }, label && /* @__PURE__ */ React.createElement(
    Label,
    {
      className: cn(formControlClassNames.label, className == null ? void 0 : className.label),
      htmlFor
    },
    label
  ), optional && /* @__PURE__ */ React.createElement("div", { className: "p-0 text-foreground-subtle my-body-xs" }, "Optional")), tooltip), /* @__PURE__ */ React.createElement("div", { className: cn(formControlClassNames.root, className == null ? void 0 : className.root) }, children, caption && /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cn(formControlClassNames.caption, className == null ? void 0 : className.caption)
    },
    caption
  ), error && /* @__PURE__ */ React.createElement("div", { className: cn(formControlClassNames.error, className == null ? void 0 : className.error) }, error), feedback && /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cn(formControlClassNames.feedback, className == null ? void 0 : className.feedback)
    },
    feedback
  )));
};

export {
  formControlClassNames,
  FormControl
};
